import { useEffect, useState } from "react"
import StackedBarChart from "../../../components/Charts/StackedBarChart"
import { IInformacionProyectos } from "../../../interfaces/InformacionProyectos"
import { mapCategoriesInfoProyectos, mapDataInfoProyectos } from "../../../util/generic";
import { ChartContainerLoader } from "../../../components/Generic/Charts";
import { getInfoProyectos, getInfoProyectosPrograma } from "../../../api/informacionProyectos";
import { useTranslation } from "react-i18next";

const Resultados:React.FC<{ code: string }> = ({code}) => {
    const {t} = useTranslation('translation',{keyPrefix: 'resultados'})

    const [chartData, setChartData] = useState<IInformacionProyectos[]>();

    useEffect(() => {
        getInfoProyectosPrograma(code)
        .then((res) => {
            setChartData(res)
            return
        })
    }, [code]);

    if(!chartData) {
        return (
            <ChartContainerLoader colSize="12" />
        )
    }

    return (
        <StackedBarChart
          categoriesData={mapCategoriesInfoProyectos(chartData)}
          data={mapDataInfoProyectos(chartData)}
          yAxisTitle={t("proyectos")}
          chartName={t("resultados")}
        />
    )
}

export default Resultados